import { ReactElement } from 'react'
import { Vector3 } from 'three'
import { useTheme } from '@mui/material'
import { Line } from '@react-three/drei'

export interface SceneLineMarkerPoint {
  x: number
  y: number
  z: number
}

interface Props {
  lines: SceneLineMarkerPoint[][]
  color?: string
  lineWidth?: number
  dashed?: boolean
  dashSize?: number
  gapSize?: number
  dashScale?: number
  renderOrder?: number
  disableDepthTest?: boolean
}

const SceneLineMarker = ({
  lines,
  color,
  lineWidth = 3,
  dashed = false,
  dashSize = 1,
  gapSize = 1,
  dashScale = 1,
  renderOrder = 999,
  disableDepthTest = false,
}: Props): ReactElement => {
  const { scenePalette } = useTheme()

  return (
    <>
      {lines.map((line, index) => (
        <Line
          key={index}
          points={line.map(point => new Vector3(point.x, point.y, point.z))}
          color={color || (scenePalette.highlightDark as string)}
          lineWidth={lineWidth}
          dashed={dashed}
          dashSize={dashSize}
          gapSize={gapSize}
          dashScale={dashScale}
          renderOrder={renderOrder}
          depthTest={!disableDepthTest}
          transparent={disableDepthTest}
        />
      ))}
    </>
  )
}

export default SceneLineMarker
